<template>
    <button v-if="canEditHospitalRequest"
            class="blue-button" @click="openSetTransportModal(patient)">
<!--        <i class="fa-sharp fa-regular fa-circle-h"></i>-->
        <span>{{ pgettext('action', 'Select medical facility') }}</span>
    </button>
</template>

<script>
import {HpoRole} from "../../../../choices";
import {patientInHospital, patientTransported} from "../utils";

export default {
    name: 'TransportSelectButton',
    emits: ['setEditedTransportData'],
    props: {
        patient: {
            type: Object,
            required: true
        },
        member: {
            type: Object,
            required: true
        },
    },
    setup() {
        return {
            // Imports
            HpoRole,
            patientInHospital,
            patientTransported,
        }
    },
    computed: {
        canEditHospitalRequest() {
            return (
                this.member.role === this.HpoRole.ZOS &&
                this.patient.transport &&
                !this.patientTransported(this.patient) &&
                !this.patientInHospital(this.patient)
            )
        },
        canCancelTransport() {
            return (
                this.member.role === HpoRole.ZOS &&
                this.patientTransported(this.patient) &&
                !this.patientInHospital(this.patient)
            )
        }
    },
    methods: {
        openSetTransportModal(patient) {
            this.$emit('setEditedTransportData', patient)
        },
    }
}

</script>
